function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1491_13604)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.80724 5.36564C3.80724 4.34094 2.95496 3.51025 1.90362 3.51025C0.852279 3.51025 0 4.34094 0 5.36564C0 6.39034 0.852279 7.22102 1.90362 7.22102C2.95496 7.22102 3.80724 6.39034 3.80724 5.36564Z",
  fill: "#ADC8FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.80699 12.3234C3.80699 11.2987 2.95471 10.468 1.90337 10.468C0.852035 10.468 -0.000244141 11.2987 -0.000244141 12.3234C-0.000244141 13.3481 0.852035 14.1788 1.90337 14.1788C2.95471 14.1788 3.80699 13.3481 3.80699 12.3234Z",
  fill: "#6690FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2972 10.468H7.85113C6.79979 10.468 5.94751 11.2987 5.94751 12.3234C5.94751 13.3481 6.79979 14.1788 7.85113 14.1788H18.2972C19.3486 14.1788 20.2009 13.3481 20.2009 12.3234C20.2009 11.2987 19.3486 10.468 18.2972 10.468Z",
  fill: "#ADC8FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2975 3.46802H7.85137C6.80003 3.46802 5.94775 4.2987 5.94775 5.3234C5.94775 6.3481 6.80003 7.17879 7.85137 7.17879H18.2975C19.3488 7.17879 20.2011 6.3481 20.2011 5.3234C20.2011 4.2987 19.3488 3.46802 18.2975 3.46802Z",
  fill: "#6690FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.80724 19.7449C3.80724 18.7202 2.95496 17.8895 1.90362 17.8895C0.852278 17.8895 0 18.7202 0 19.7449C0 20.7696 0.852278 21.6003 1.90362 21.6003C2.95496 21.6003 3.80724 20.7696 3.80724 19.7449Z",
  fill: "#254EDB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.8923 18H7.90362C6.85228 18 6 18.8307 6 19.8554C6 20.8801 6.85228 21.7108 7.90362 21.7108H17.8923C18.9436 21.7108 19.7959 20.8801 19.7959 19.8554C19.7959 18.8307 18.9436 18 17.8923 18Z",
  fill: "#254EDB"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1491_13604"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 27,
  fill: "white"
})));

function SvgIllustration3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration3);
export default __webpack_public_path__ + "static/media/illustration3.90f32d7fd1d5f82464ab595d47b2bf0f.svg";
export { ForwardRef as ReactComponent };